var map = {
	"./Demo.mp4": "DUG4",
	"./体检平台.mp4": "4Ke0",
	"./决策云.mp4": "DCx+",
	"./广州大屏.mp4": "D3s1"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+XFJ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mov ^\.\/.*\.mp4$
// module id = +XFJ
// module chunks = 1